import { Component, effect, inject, input, output } from '@angular/core';

import { ButtonComponent, FormPhoneComponent, UI_FORM_IMPORTS } from '@program-suite/ui';
import { AddAgentViewModel, LookupViewModel } from '@program-suite/data-common';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { LookupStore } from '@program-suite/data-common';

@Component({
  selector: 'lib-ui-agency-users-form',
  imports: [
    ButtonComponent,
    ...UI_FORM_IMPORTS,
    ReactiveFormsModule,
    FormPhoneComponent
],
  templateUrl: './ui-agency-users-form.component.html',
  styleUrl: './ui-agency-users-form.component.scss',
})
export class UiAgencyUsersFormComponent {
  formSubmit = output<{users: AddAgentViewModel[], agencyId: number}>();
  roles = input<LookupViewModel[]>([]);
  agencyId = input<number | null>(null);
  initialUserRows = 2; // Default number of rows
  usersForm!: FormGroup;
  lookupStore = inject(LookupStore);

  constructor(private fb: FormBuilder) {
    this.usersForm = this.fb.group({
      agencyId: [this.agencyId() ? this.agencyId() : '', Validators.required],
      users: this.fb.array([]),
    });

    for (let i = 0; i < this.initialUserRows; i++) {
      this.addUser();
    }
    effect(() => {
      if (this.agencyId() !== null) {
        this.usersForm.get('agencyId')?.setValue(this.agencyId());
      }
    });
  }

  get usersFormArray(): FormArray {
    return this.usersForm.get('users') as FormArray;
  }

  addUser() {
    this.usersFormArray.push(this.createUserForm());
  }

  removeUser(index: number) {
    this.usersFormArray.removeAt(index);
  }

  private createUserForm(): FormGroup {
    return this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      role: ['', Validators.required],
      phone: [''],
    });
  }

  submit() {
    if (this.usersForm.get('agencyId')?.invalid) {
      this.usersForm.get('agencyId')?.markAsTouched();
      return;
    }
    const users = this.usersFormArray.controls
    .filter(control => this.isFilledRow(control.value))
    .map(control => {
      const user = control.value;
      return {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        role: user.role,
        status: 'active',
        phone: user.phone,
      } as AddAgentViewModel;
    });

    if (users.length > 0) {
      this.formSubmit.emit({users: users, agencyId: Number(this.agencyId() ? this.agencyId() : this.usersForm.get('agencyId')?.value)});
    } 
  }

  // Prevents empty rows from being submitted
  private isFilledRow(user: any): boolean {
    return (
      (user.firstName && user.firstName.trim() !== '') &&
      (user.lastName && user.lastName.trim() !== '') &&
      (user.email && user.email.trim() !== '') &&
      (user.role && user.role !== '')
    );
  }
}